
























































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { User } from "@/swagger/models";
import { routes } from "@/router/router";
import { useUiStore } from "@/pinia/ui-store";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "navbar",
})
export default class Navbar extends Vue {
    uiStore = useUiStore();
    user: User | null = null;

    get routeParams() {
        return {
            customerId: this.$context.customer?.id,
            officeId: this.$context.office?.id,
        };
    }

    get displayedRoutes() {
        return routes
            .filter((r) => r.meta.includeInSubNavigation)
            .sort((r1, r2) => (r1.meta.order > r2.meta.order || !r1.meta.order ? 1 : -1));
    }

    get displayedBottomRoutes() {
        return routes
            .filter((r) => r.meta.includeInBottomNavigation)
            .sort((r1, r2) => (r1.meta.order > r2.meta.order || !r1.meta.order ? 1 : -1));
    }

    get logoAlt() {
        return `v${process.env.VUE_APP_PACKAGE_VERSION} / ${process.env.VUE_APP_GITHUB_SHA || "hash unavailable"}`;
    }

    get appVersion() {
        return `v${process.env.VUE_APP_PACKAGE_VERSION}`;
    }

    get appHash() {
        return `${process.env.VUE_APP_GITHUB_SHA || "hash unavailable"} - click to reload`;
    }

    get isZonesItemActive() {
        return this.$route.fullPath.includes("zone/");
    }

    async mounted() {
        // Todo: When coming back from Okta, getUser may return undefined for a while
        // This is a little workaround, but should be fixed in the future.
        while (!this.user) {
            this.user = await this.$auth.getUser();
            await new Promise((r) => setTimeout(r, 250));
        }
    }

    async logOut() {
        if (!confirm("Are you sure you want to log out?")) return;
        await this.$auth.logout("/");
    }

    forceReload() {
        // @ts-ignore
        location.reload(true);
    }
}
